import { makeStyles } from "@material-ui/core"

export const useTableStyles = makeStyles({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    container: {
        position: "relative",
    },
})

export const useDialogStyles = makeStyles({
    cancelButton: {
        backgroundColor: "#f44336",
        color: "white",
        "&:hover": {
            backgroundColor: "#f44336",
        },
        marginLeft: 4,
    },
    unfinishedButton: {
        backgroundColor: "#ff9800",
        color: "white",
        "&:hover": {
            backgroundColor: "#ff9800",
        },
        marginLeft: 4,
    },
    finishedButton: {
        backgroundColor: "#4caf50",
        color: "white",
        "&:hover": {
            backgroundColor: "#4caf50",
        },
        marginLeft: 4,
    },
})

export const useFieldInputStyles = makeStyles({
    textWrap: {
        marginTop: 10,
        width: "100%",
    },
})

export const useAnnexItemStyles = makeStyles({
    root: {
        border: "1px solid #ddd",
        borderRadius: "10px",
        marginBottom: 10,
        marginRight: 10,
        position: "relative",
    },
    itemWrap: {
        padding: "0px !important",
        marginRight: 10,
    },
    imageIcon: {
        width: 50,
        height: "auto",
    },
    textWrap: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: 170,
        whiteSpace: "nowrap",
        margin: 0,
    },
    mask: {
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        borderRadius: "10px",
        position: "absolute",
        background: "rgba(0,0,0,.8)",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        color: "white",
        "& a": {
            color: "white",
            textDecoration: "none",
        },
    },
})
